export default __webpack_public_path__ + "static/media/logo.abc9a668.png";